import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mui/material";

export interface ConfirmDocumentDeleteModalProps {
  open: boolean;
  filename?: string;
  onDelete: () => void;
  onCancel: () => void;
}

export function ConfirmDocumentDeleteModal({
  open,
  filename,
  onCancel,
  onDelete,
}: ConfirmDocumentDeleteModalProps) {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle>
        Permanently delete {filename ? `"${filename}"` : "this file"}?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          This file will be removed from the application.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button color="error" onClick={onDelete}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
